document.addEventListener('click', (event) => {
  const openButton = event.target.closest('#send-cart-information');
  const closeButton = event.target.closest('#close-cart-shipping-dialog');
  const closeConfirmationButton = event.target.closest('#close-direct-pay-confirmation, #close-direct-pay-confirmation-button');
  const dialog = document.getElementById('cart-shipping-dialog');
  const confirmationDialog = document.getElementById('direct-pay-confirmation-dialog');

  if (openButton && dialog) {
    dialog.showModal();
  }

  if (closeButton && dialog) {
    dialog.close();
  }

  if (closeConfirmationButton && confirmationDialog) {
    confirmationDialog.close();
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('#cart-shipping-information');
  if (!form) return;
  event.preventDefault();

  const dialog = document.getElementById('cart-shipping-dialog');
  const button = document.getElementById('submit-cart-shipping');
  const status = document.getElementById('cart-shipping-status');
  if (!form || !form.reportValidity()) return;

  const endpoint = form.dataset.cloudEndpoint;
  if (!endpoint) {
    status.textContent = 'The Google Cloud endpoint has not been configured.';
    return;
  }

  button.disabled = true;
  status.textContent = 'Sending...';

  try {
    const cartResponse = await fetch(form.dataset.cartUrl);
    if (!cartResponse.ok) throw new Error('Unable to load cart');

    const cart = await cartResponse.json();
    const shippingInformation = Object.fromEntries(new FormData(form).entries());
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        customerID: form.dataset.customerId,
        cartInfo: {
          token: cart.token,
          itemCount: cart.item_count,
          items: cart.items.map((item) => ({
            variantId: item.variant_id,
            quantity: item.quantity
          })),
          totalPrice: cart.total_price,
          currency: cart.currency,
          shippingInformation
        },
        timestamp: new Date().toISOString()
      })
    });

    if (!response.ok) {
      let message = 'Cloud request failed';
      try {
        const errorResponse = await response.json();
        if (errorResponse.message) message = errorResponse.message;
      } catch (error) {
        // The endpoint may return an empty or non-JSON error response.
      }
      throw new Error(message);
    }
    status.textContent = 'Shipping information sent successfully.';
    if (dialog) dialog.close();
    const confirmationDialog = document.getElementById('direct-pay-confirmation-dialog');
    if (confirmationDialog) confirmationDialog.showModal();
  } catch (error) {
    status.textContent = error.message || 'We could not send the shipping information. Please try again.';
  } finally {
    button.disabled = false;
  }
});